import { useState } from 'react';
import { buildItinerary } from '../services/itineraryBuilder';
import useTripStore from '../context/TripStore';

/**
 * Hook for generating itineraries
 */
export const useItineraryGenerator = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);
  const { setItinerary, setIsGenerating: setStoreGenerating, trip, places, settings } = useTripStore();

  const generate = async () => {
    console.log('useItineraryGenerator.generate() called');
    console.log('Current state:', { trip, placesCount: places.length, settings });

    setIsGenerating(true);
    setStoreGenerating(true);
    setError(null);

    try {
      // Only validate required data - start location and places
      if (!trip.startLocation) {
        throw new Error('Please set a starting location');
      }

      if (places.length === 0) {
        throw new Error('Please add at least one place to visit');
      }

      // Use defaults for optional fields
      const today = new Date().toISOString().split('T')[0];
      const cityName = trip.city?.name ||
        trip.startLocation?.address?.split(',').slice(-2, -1)[0]?.trim() ||
        'Your City';

      // Prepare trip data for API
      const tripData = {
        city: { name: cityName },
        date: trip.date || today,
        startTime: trip.startTime || '09:00',
        endTime: trip.endTime || '21:00',
        startLocation: trip.startLocation,
        endLocation: trip.endLocation || trip.startLocation,
        places: places.map(place => ({
          name: place.name,
          placeId: place.placeId,
          coordinates: place.coordinates,
          priority: place.priority || 'want_to_see',
          lockedTime: place.lockedTime,
        })),
        optimizationMode: settings?.optimizationMode || 'optimize_route',
      };

      console.log('Calling buildItinerary with tripData:', tripData);
      const itinerary = await buildItinerary(tripData);
      console.log('buildItinerary returned:', itinerary);

      setItinerary(itinerary);
      console.log('Itinerary set in store');

      return itinerary;
    } catch (err) {
      console.error('Error in generate():', err);
      setError(err.message);
      throw err;
    } finally {
      setIsGenerating(false);
      setStoreGenerating(false);
    }
  };

  return {
    generate,
    isGenerating,
    error,
  };
};
